// angular
import { NgClass, NgOptimizedImage } from '@angular/common';
import { AfterViewInit, Component, effect, input } from '@angular/core';
// interfaces & env
import { IMedia } from '@app/shared/interfaces/media.interface';
import { environment } from '@environments/environment';
// pipes
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';
// animations
import { beginSliderAnimation } from '@app/core/shared/animations/begin-slider.animation';

@Component({
  selector: 'pwj-begin-page-slider',
  standalone: true,
  imports: [NgOptimizedImage, ImageSourcePipe, NgClass],
  animations: [beginSliderAnimation],
  templateUrl: './begin-page-slider.component.html',
  styleUrl: './begin-page-slider.component.scss',
})
export class BeginPageSliderComponent {
  public mainImage?: IMedia;
  public otherImage?: IMedia;
  public counter: number = 0;
  public showMainImage: boolean = true;
  // inputs
  mediaData = input<IMedia[]>();
  isFullWidth = input<boolean>(false);

  constructor() {
    effect(() => {
      // initialize slider image
      this.setSliderImage();
    });
  }

  public nextImage() {
    this.showMainImage = false;

    // implement delay to show animations for slider
    setTimeout(() => {
      // set next image data
      if ((this.mediaData()?.length || 0) - 1 <= this.counter) {
        this.counter = 0;
      } else {
        this.counter = ++this.counter;
      }
      this.setSliderImage();
    }, environment.beginPageSliderTimeOut);
  }

  ngOnDestroy(): void {
    // set counter to 0 on destroy component
    this.counter = 0;
  }

  public setSliderImage() {
    // set slider data
    if (this.mediaData()) {
      // set main image src
      this.mainImage = this.mediaData()?.[this.counter];

      // set other image src
      if ((this.mediaData()?.length || 0) - 1 <= this.counter) {
        this.otherImage = this.mediaData()?.[0];
      } else {
        this.otherImage = this.mediaData()?.[this.counter + 1];
      }
    }
    this.showMainImage = true;
  }
}
